/**
 * Don't edit this file directly instead update the text in the language file Sheet
 * and export the JSON from there and copy the JSON content here.
 *
 *  Language file:
 *  https://docs.google.com/spreadsheets/d/1T5vEuhUDvGG7KhITjrCGQbDnAeG5MOXdBIl9M7sBd4s
 *
 * */
export const translations = {
    en: {
        page: { key: 'EN' },
        shared: { select_your_language: 'Select your language' },
        receipts: {
            title: 'Receipts',
            sub_title_1: 'Because sometimes you just need that piece of evidence.',
            sub_title_2: 'In case you need an alibi.',
            form: {
                session_country: 'Session country',
                location: 'Station',
                session_date: 'Session date',
                exact_amount: 'Exact amount',
                select_fastned_station: 'Select Fastned station',
            },
            info_text: 'Please note, you can retrieve a receipt up to 12 months after a charging session. Only receipts from sessions started with the payment terminal can be retrieved here.',
        },
        buttons: {
            search_receipt: 'Search receipt',
            try_again: 'Try again',
            download_receipt: 'Download receipt',
            back: 'Back',
            go_to_main_page: 'Go to main page',
        },
        search: {
            searching: 'Searching through a pile of receipts...',
            generating: 'Handwriting your receipt...',
        },
        receipt_not_found: {
            title: 'Too bad',
            text: 'We could not find your receipt. Try again or',
            link_text: 'contact support.',
        },
        receipt_found: { title: 'Got it!', text: 'Download your receipt below 👇' },
        page_not_found: {
            title: 'Page not found',
            text: "Looks like you're looking for something that ain't there...",
        },
        receipt_found_email: {
            recipient: 'support@fastnedcharging.com',
            subject: 'Receipt request',
            body_1: 'Hi Fastned,',
            body_2: 'I was not able to find my receipt on the website. ',
            body_3: 'I hereby request a receipt for my charging session.',
            body_4: 'My session info:',
            session_country: '• Session country:  {{country}}',
            fastned_station: '• Fastned station:  {{station}}',
            session_date: '• Session date: {{date}}',
            exact_amount: '• Exact amount: {{amount}}',
        },
    },
    nl: {
        page: { key: 'NL' },
        shared: { select_your_language: 'Select your language' },
        receipts: {
            title: 'Bonnetjes',
            sub_title_1: 'Want soms heb je gewoon dat stukje bewijs nodig.',
            sub_title_2: 'Voor het geval je een alibi nodig hebt.',
            form: {
                session_country: 'Land laadsessie',
                location: 'Station',
                session_date: 'Datum laadsessie',
                exact_amount: 'Exact bedrag',
                select_fastned_station: 'Selecteer Fastned-station',
            },
            info_text: 'Let op: je kunt een bon tot 12 maanden na een laadsessie opvragen. Alleen bonnetjes van sessies die gestart zijn met de pinautomaat kunnen hier worden opgevraagd.',
        },
        buttons: {
            search_receipt: 'Zoek bonnetje',
            try_again: 'Probeer opnieuw',
            download_receipt: 'Bonnetje downloaden',
            back: 'Terug',
            go_to_main_page: 'Terug naar start',
        },
        search: {
            searching: 'De stapel bonnetjes doorzoeken...',
            generating: 'Bonnetje aan het uitschrijven...',
        },
        receipt_not_found: {
            title: 'Jammer',
            text: 'We konden je bonnetje niet vinden. Probeer het opnieuw of',
            link_text: 'neem contact op met support.',
        },
        receipt_found: { title: 'Gevonden!', text: 'Download je bonnetje hieronder 👇' },
        page_not_found: {
            title: 'Pagina niet gevonden',
            text: 'Het lijkt erop dat je naar iets zoekt dat er niet is...',
        },
        receipt_found_email: {
            recipient: 'support@fastnedcharging.com',
            subject: 'Aanvraag bon',
            body_1: 'Dag Fastned,',
            body_2: 'Ik kon mijn bon via de website niet vinden.',
            body_3: 'Hierbij vraag ik een bon aan van mijn laadsessie.',
            body_4: 'Mijn sessie-gegevens:',
            session_country: '• Land laadsessie: {{country}}',
            fastned_station: '• Fastned-station:  {{station}}',
            session_date: '• Datum laadsessie: {{date}}',
            exact_amount: '• Exact bedrag: {{amount}}',
        },
    },
    de: {
        page: { key: 'DE' },
        shared: { select_your_language: 'Select your language' },
        receipts: {
            title: 'Belege',
            sub_title_1: 'Da manchnmal ein Nachweis notwendig ist.',
            sub_title_2: 'Für den Fall, dass Du ein Alibi brauchst.',
            form: {
                session_country: 'Land Ladevorgang',
                location: 'Station',
                session_date: 'Datum Ladevorgang',
                exact_amount: 'Genauer Betrag',
                select_fastned_station: 'Fastned Station auswählen',
            },
            info_text: 'Bitte beachte, dass Du einen Beleg bis zu 12 Monate nach Deinem Ladevorgang abrufen kannst. Nur Belege von Ladevorgänge, die mit dem Bezahlterminal gestartet wurden, können hier abgerufen werden.',
        },
        buttons: {
            search_receipt: 'Suche Beleg',
            try_again: 'Erneut versuchen',
            download_receipt: 'Beleg herunterladen',
            back: 'Zurück',
            go_to_main_page: 'Zurück zur Startseite',
        },
        search: {
            searching: 'Einen Stapel von Belegen durchsuchen...',
            generating: 'PDF des Belegs wird erstellt...',
        },
        receipt_not_found: {
            title: 'Schade',
            text: 'Wir konnten Deinen Beleg nicht finden. Erneut versuchen oder',
            link_text: 'contact support.',
        },
        receipt_found: { title: 'Gefunden!', text: 'Anbei kannst Du Deinen Beleg herunterladen 👇' },
        page_not_found: {
            title: 'Seite nicht gefunden',
            text: 'Es scheint, als ob Du nach etwas suchst, das es nicht gibt...',
        },
        receipt_found_email: {
            recipient: 'support@fastnedcharging.com',
            subject: 'Beleg anfragen',
            body_1: 'Hallo Fastned,',
            body_2: 'Ich konnte meinen Beleg auf der Website nicht finden.',
            body_3: 'Hiermit frage ich einen Beleg für meinen Ladevorgang an.',
            body_4: 'Details meines Ladevorgangs:',
            session_country: '• Land Ladevorgang: {{country}}',
            fastned_station: '• Fastned Station: {{station}}',
            session_date: '• Datum des Ladevorgang: {{date}}',
            exact_amount: '• Exakter Betrag: {{amount}}',
        },
    },
    fr: {
        page: { key: 'FR' },
        shared: { select_your_language: 'Select your language' },
        receipts: {
            title: 'Reçus',
            sub_title_1: "Parce qu'une preuve est parfois nécessaire.",
            sub_title_2: "Au cas où vous auriez besoin d'un alibi.",
            form: {
                session_country: 'Pays de la session',
                location: 'Station',
                session_date: 'Date de la session de recharge',
                exact_amount: 'Montant exact',
                select_fastned_station: 'Selectionner la station Fastned',
            },
            info_text: "Veuillez noter que vous pouvez récupérer un reçu jusqu'à 12 mois après la session de recharge. Seuls les reçus pour les sessions commencées avec un terminal de paiement peuvent être obtenues ici. ",
        },
        buttons: {
            search_receipt: 'Recherchez un reçu',
            try_again: 'Essayer à nouveau',
            download_receipt: 'Telecharger le reçu',
            back: 'Retour',
            go_to_main_page: 'Retour à la page principale',
        },
        search: {
            searching: 'Recherche dans une pile de reçus...',
            generating: 'Ecriture de votre reçu à la main...',
        },
        receipt_not_found: {
            title: 'Dommage',
            text: "Nous n'avons pas pu trouver votre reçu. Essayez à nouveau ou",
            link_text: 'contactez notre support clients.',
        },
        receipt_found: { title: 'Trouvé ! ', text: 'Téléchargez votre reçu maintenant 👇' },
        page_not_found: {
            title: 'Page introuvable',
            text: "On dirait que vous cherchez quelque chose qui n'est pas là...",
        },
        receipt_found_email: {
            recipient: 'support@fastnedcharging.com',
            subject: 'Demande reçu',
            body_1: 'Bonjour Fastned,',
            body_2: 'Je n’ai pas pu trouver mon reçu sur le site web.',
            body_3: 'Je demande par la présente un reçu pour ma session de recharge.',
            body_4: 'Les informations pour ma session:',
            session_country: '• Pays de la session: {{country}}',
            fastned_station: '• Station Fastned: {{station}}',
            session_date: '• Date de la Session: {{date}}',
            exact_amount: '• Montant exact: {{amount}}',
        },
    },
};
